import type { CtrlApiError } from "@repo/sdk";
import type { CTRL_SCHEMA } from "@repo/sdk/types";
import { useHttp, type HttpConfiguration } from "@repo/utils/hooks";
import { useCtrlClient } from "../contexts/CtrlApiProvider";

export type TenantTool = CTRL_SCHEMA["OpenapigenTenantTool"];

/** SWR key for a tenant's tool status list. */
export const tenantToolsKey = (tenantId: string) => `tenants/${tenantId}/tools`;

/**
 * Fetch the tools visible to a tenant with effective settings, adopted and
 * available versions, and status. A 503 CtrlApiError means the cell has no
 * catalog configured.
 */
export function useTenantTools(
  tenantId: string | null | undefined,
  config?: HttpConfiguration,
) {
  const client = useCtrlClient();

  return useHttp<TenantTool[], CtrlApiError>(
    tenantId ? tenantToolsKey(tenantId) : null,
    async () => {
      if (!tenantId) throw new Error("Tenant ID is required");
      const res = await client.getTenantTools(tenantId);
      return res.tools ?? [];
    },
    config,
  );
}
